import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button, Card, Table } from "reactstrap";
import SimpleBar from "simplebar-react";
import { get, del, put } from "../../../api/axios";
import endpoints from "../../../api/endpoints";
import { toast, Bounce } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";

export default function ContactUsDetails() {
  const location = useLocation();
  const navigate = useNavigate();
  const blogId = location.state?.blogData?.data?.id;
  const [blogData, setblogData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchblog = async (id) => {
    setLoading(true);
    try {
      const response = await get(`${endpoints.contact}/${id}`);
      setblogData(response?.data?.data);
    } catch (error) {
      console.error("Error fetching contact us data:", error);
      setblogData(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (blogId) {
      fetchblog(blogId);
    }
  }, [blogId]);

  const handleEditBlog = () => {
    if (blogData) {
      navigate(`/add-contactus?blogId=${blogId}`);
    }
  };

  const handleDeleteBlog = async () => {
    try {
      await del(`${endpoints.request}/${blogId}`);
      setblogData((prevData) => prevData.filter((blog) => blog.id !== blogId));
      toast.success("Contact us Deleted Successfully", {
        position: "bottom-center",
        theme: "colored",
        transition: Bounce,
      });
      navigate("/list-contactus");
    } catch (error) {
      console.error("Error deleting request:", error);
    }
  };

  return (
    <div className="">
      <Container fluid>
        <Card className="rounded-4 p-4" style={{ minHeight: "550px" }}>
          <Row className="justify-content-between align-items-center">
            <Col md={6}>
              <h2 className="fw-bold font-size-20 ff-sora primary-black">
                Contact Us Details
              </h2>
            </Col>
            <Col md={6} xs={12} className="d-flex justify-content-end">
              <Button
                color="white"
                className="me-2 rounded-pill1"
                onClick={handleDeleteBlog}
              >
                Delete Contact us
              </Button>
              <Button className="rounded-pill" onClick={handleEditBlog}>
                Edit Contact us
              </Button>
            </Col>
          </Row>

          <Row>
            <Col>
              <h6
                className="font-size-16 fw-bold ff-sora secondary-black"
                style={{ color: "#525252" }}
              >
                {blogData.userName}
              </h6>
              <h6
                className="font-size-16 fw-bold ff-sora secondary-black"
                style={{ color: "#525252" }}
              >
                {blogData.contactInfo}
              </h6>
              <h6
                className="font-size-16 fw-bold ff-sora secondary-black"
                style={{ color: "#525252" }}
              >
                {blogData.reason}
              </h6>

              <p className="font-size-14 fw-normal ff-sora light-black mt-3">
                {blogData.description}
              </p>
            </Col>
          </Row>
        </Card>
        <div
          className="d-flex justify-content-between align-items-center"
          style={{
            height: "10px",
            position: "sticky",
            bottom: "0",
            zIndex: "10",
          }}
        ></div>
      </Container>
    </div>
  );
}
